<section class="entity-identification">
  <div class="entity-identification__header">
    <div class="entity-identification__header-row">
      <div class="entity-identification__title-wrapper">
        <h2 class="entity-identification__title">Entity Identification</h2>
        <button
          *ngIf="canEdit"
          type="button"
          class="entity-identification__edit-btn"
          (click)="toggleEdit()"
          [disabled]="isSaving"
          aria-label="Edit Entity Identification"
        >
          <span class="material-symbols-outlined" aria-hidden="true">edit</span>
        </button>
      </div>
      <div class="entity-identification__actions" *ngIf="isEditing">
        <app-az-button
          label="Discard"
          variant="default"
          [showIcon]="false"
          [disabled]="isSaving"
          (click)="discard()"
        />
        <app-az-button
          label="Save Changes"
          variant="primary"
          [showIcon]="false"
          [disabled]="!hasChanges || isSaving"
          (click)="saveChanges()"
        />
      </div>
    </div>
    <p class="entity-identification__subtitle">
      Core details used to uniquely identify each legal entity.
    </p>
  </div>

  <div class="entity-identification__fields">
    <div class="entity-identification__row">
      <app-form-field label="Legal Entity Name:" [value]="legalEntityName" [disabled]="true" />
      <app-form-field
        label="Official Registration Number:"
        [value]="currentRegistrationNumber"
        [disabled]="!isEditing"
        (valueChange)="onRegistrationNumberChange($event)"
      />
      <app-form-field
        label="Associated Authorized Signatory:"
        [value]="currentAuthorizedSignatory"
        [disabled]="!isEditing"
        (valueChange)="onAuthorizedSignatoryChange($event)"
      />
    </div>

    <div class="entity-identification__row">
      <app-form-field label="Address:" [value]="address" [disabled]="true" />
      <app-form-field label="Country:" [value]="country" [disabled]="true" />
    </div>
  </div>
</section>
